var _ = require('underscore');

var labels = {
  preGame: { text: 'Pre-game', color: '#F3E80C' },
  inGame: { text: 'In-game', color: '#3FC380' },
  floating: { text: 'Floating', color: '#3498DB' },
  unassigned: { text: 'Unassigned', color: '#E8E8E8' },
};

labels.all = _.values(labels);

var categories = {
  uncategorized: { text: 'Uncategorized' },
};

module.exports = {
  labels,
  categories,
};
